/**
 * @generated SignedSource<<c87cdc2e121fbee2ab9fcce32b398465>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type MilestoneCreateFormRepositoryQuery$data = {
  readonly id: string;
  readonly nameWithOwner: string;
  readonly viewerCanPush: boolean;
  readonly " $fragmentType": "MilestoneCreateFormRepositoryQuery";
};
export type MilestoneCreateFormRepositoryQuery$key = {
  readonly " $data"?: MilestoneCreateFormRepositoryQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"MilestoneCreateFormRepositoryQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MilestoneCreateFormRepositoryQuery",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameWithOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanPush",
      "storageKey": null
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "b8b64c71ee3c5df6687e46a2d9957a8d";

export default node;
